<template lang="pug">
  .satisfaction-guarantee-v2.container
    .row.text-center.xs-f-small.md-f-medium.lg-f-small.max-at-tweak
      .fixed-width-tweak-upper
        .outer-wrap.xs-12
          .satisfaction-wrap.xs-12
            .text-wrap.xs-text-center.sm-text-left
              .image-wrap.a-box-xs-1x1
                .a-box-content
                  img-box(media-id="5129")
              p.xs-f-small.lg-f-medium.max-at-tweak We want you to love your hair. If you don't&mdash;we'll send you another box, on us. Still not happy? We'll refund your money on your first box, 100%

</template>

<script>
  export default {
    name: "SatisfactionGuarantee"
   }
</script>

<style scoped lang="stylus">
  .satisfaction-guarantee-v2
    background-color #e6eef6

    .satisfaction-wrap
      padding 1.5em 0

    .text-wrap
      position relative
      display inline-block
      vertical-align top
      width 68%
      margin-left 15%
      padding 0 0%

    .image-wrap
      position absolute

      img
        width 100%

    @media mq-mobile
      .outer-wrap
        padding 0 5%

      .text-wrap
        width 100%
        margin 0
        padding 0 8%
        padding-top 5.5em

      .image-wrap
        width 9em
        top -3em
        left 50%
        margin-left -4.5em

    @media mq-tablet
      .outer-wrap
        padding 0 2%

      .image-wrap
        top -4em
        right 100%
        width 10em

      .text-wrap
        margin-left 23%

    @media mq-desktop-md
      .outer-wrap
        padding 0 3%

      .image-wrap
        top -4em
        right 100%
        width 11em

      .text-wrap
        width 56%
        margin-left 23%

    @media mq-desktop-plus
      .outer-wrap
        padding 0 3%

      .satisfaction-wrap
        padding 1.75em 0

      .image-wrap
        top -4em
        right 100%
        width 25%
</style>